import dynamic from 'next/dynamic'

export const ObservedSnackbar = dynamic(() => import('./snackbar'))
